import { IPackageListingState, IEventFilter, defaultPackageListingModel } from '../../classes/package-listing';
import { IProduction, IPerformanceGroup, IPackage, IPerformancePricing, IPerformance } from '../../custom/classes/production';

import { ActionType, IPackageListingStateAction } from '../../classes/package-listing-actions';

import { filterMap } from '../../helpers/map-helpers';

import { cloneDeep } from 'lodash';
/**
 * Returns the new search state given a particular action. This where all of the application
 * logic resides.
 */
export default function calendarReducer(state: IPackageListingState<IPackage> = defaultPackageListingModel, action: IPackageListingStateAction) {
    switch (action.type) {
        case ActionType.LoadPackage: {
            return { ...state, packageDetail: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.LoadPackages: {
            return { ...state, packages: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePerformancesFilter: {
            const updating = true;
            const addedFilterFunction = action.value;

            var eventFilter: IEventFilter[] = null;
            if (state.eventFilter.some(filter => { return filter.key === addedFilterFunction.key })) {
                eventFilter = state.eventFilter.filter(filter => !(filter.key === addedFilterFunction.key)).concat([addedFilterFunction]);
            } else {
                eventFilter = state.eventFilter.concat([addedFilterFunction])
            }
            const filterFunction = (event) => eventFilter.map(fil => {
                return fil.filter;
            }).every(f => f(event));

            return { ...state, eventFilter, filterFunction, updating } as IPackageListingState<IPackage>;
        }

        case ActionType.RemovePerformancesFilter: {
            const eventFilter = state.eventFilter.filter(filter => filter.key !== action.value);
            const filterFunction = (event: IProduction) => eventFilter.map(filter => filter.filter).every(func => func(event));

            return { ...state, eventFilter, filterFunction, updating: true } as IPackageListingState<IPackage>;
        }

        case ActionType.RemoveAllPerformancesFilters: {
            return { ...state, eventFilter: [], filterFunction: (event: IProduction) => true, updating: true } as IPackageListingState<IPackage>;
        }

        case ActionType.UpdateOrderNotes: {
            return { ...state, orderNotes: action.value } as IPackageListingState<IPackage>;
        }

        case ActionType.AddItemToCart: {
            var updatedMap = state.cartItems.set(action.value.itemId, 0);

            if (action.value.packageId) {
                var addedSubPackages = state.subPackagesInCart.get(action.value.packageId);

                let updatedSubPackageList = [...action.value.itemId];

                if (addedSubPackages) {
                    updatedSubPackageList = addedSubPackages.concat(updatedSubPackageList);
                }
                var updatedSubPackageMap = state.subPackagesInCart.set(action.value.packageId, updatedSubPackageList)
            }
            return { ...state, cartItems: updatedMap, subPackagesInCart: updatedSubPackageMap ? updatedSubPackageMap: state.subPackagesInCart } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdateSeatingPreferences: {
            return { ...state, seatingPreferences: action.value } as IPackageListingState<IPackage>;
        }



        case ActionType.RemoveItemFromCart: {

            const matchedSuperPackage = state.subPackagesInCart.get(action.value);
            if (matchedSuperPackage) {
                let newPerfs = filterMap(state.cartItems, cartItem => matchedSuperPackage.indexOf(cartItem) < 0);
                let newSubPackageList = filterMap(state.subPackagesInCart, cartItem => cartItem !== action.value)
                return { ...state, cartItems: newPerfs, subPackagesInCart: newSubPackageList } as IPackageListingState<IPackage>;

            } else {
                let newPerfs = filterMap(state.cartItems, cartItem => cartItem !== action.value);
                return { ...state, cartItems: newPerfs } as IPackageListingState<IPackage>;

            }
        }

        case ActionType.PerformancesUpdated: {
            return { ...state, updating: false } as IPackageListingState<IPackage>;
        }
        case ActionType.BrowserNavigated: {
            state = action.value.state;
            return state as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePriceTypeQuantity: {
            state.priceTypeQuantity.set(action.value.priceTypeId, action.value.quantity);
            const ticketSum = Array.from(state.priceTypeQuantity.values()).reduce((total, num) => total + num, 0);
            return {
                ...state, totalNumberOfTicket: ticketSum,
                priceTypeQuantity: state.priceTypeQuantity.set(action.value.priceTypeId, action.value.quantity)
            } as IPackageListingState<IPackage>;
        }
        case ActionType.ClearPriceTypeQuantities: {
            state.priceTypeQuantity.clear();
            var defaultNumberOfTickets = 0;

            if (state.packageDetail != null && state.packageDetail.packagePriceTypes.length == 1) {
                defaultNumberOfTickets = 1;
                state.priceTypeQuantity.set(state.packageDetail.packagePriceTypes[0].priceTypeId, 1);
            }

            return { ...state, totalNumberOfTicket: defaultNumberOfTickets, priceTypeQuantity: new Map<number, number>() } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePackageProcessing: {
            return { ...state, processing: true, errorMessages: [] } as IPackageListingState<IPackage>;
        }
        case ActionType.UpdatePackageProcessingErrors: {
            return { ...state, processing: false, errorMessages: action.value } as IPackageListingState<IPackage>;
        }
        case ActionType.ReceivePerformancePricing: {
            const perfPricing: IPerformancePricing = action.value;

            var newList = state.performancePricingList.set(perfPricing.performanceId, perfPricing);

            return { ...state, performancePricingList: newList } as IPackageListingState<IPackage>;

        }
        case ActionType.ReceivePackagePricing: {
            const packagePricing = action.value;

            var newList = state.performancePricingList.set(packagePricing.packageId, packagePricing);

            return { ...state, performancePricingList: newList } as IPackageListingState<IPackage>;

        }
        case ActionType.UpdateSelectedZone: {
            var matchedPerf = filterMap(state.cartItems, p => p === action.value.itemId);

            state.cartItems.set(matchedPerf.keys().next().value, action.value.zoneId);

            var newPerfs = cloneDeep(state.cartItems);

            return { ...state, cartItems: newPerfs } as IPackageListingState<IPackage>;

        }

        case ActionType.RemoveSelectedZone: {
            var matchedItem = filterMap(state.cartItems, p => p === action.value);
            var newPerfs = state.cartItems.set(matchedItem.keys().next().value, 0);

            return { ...state, cartItems: new Map(state.cartItems) } as IPackageListingState<IPackage>;

        }

        //case ActionType.UpdatePackageZone: {

        //    return { ...state, packageInCart: state.packageInCart.set(state.packageInCart.keys().next().value, action.value.zoneId) } as IPackageListingState<IPackage>;

        //}

        //case ActionType.RemovePackageZone: {
        //    return { ...state, packageInCart: state.packageInCart.set(state.packageInCart.keys().next().value, 0) } as IPackageListingState<IPackage>;

        //}

        case ActionType.ToggleMiniCart: {
            return { ...state, miniCartOpen: action.value } as IPackageListingState<IPackage>;

        }
        
        case ActionType.InitializeCartWithSessionPerformances: {
            const newCartItems = new Map<number, number>();
            action.value.forEach(perfId => {
                if (!state.cartItems.has(perfId)) {
                    newCartItems.set(perfId, 0);
                }
            });
            return { 
                ...state, 
                cartItems: new Map([...state.cartItems, ...newCartItems])
            };
        }
        case ActionType.UpdateGeneralAdmissionIds: {
            return { ...state, generalAdmissionPerfIds: action.value };
        }
        case ActionType.LoadPwycSettings: {
            return { ...state, pwycPerformanceSettings: action.value || {} };
        }
        case ActionType.UpdatePwycAmount: {
            const key = `${action.value.performanceId}_${action.value.priceTypeId}`;
            const newAmounts = new Map(state.pwycAmounts);
            newAmounts.set(key, action.value.amount);
            return { ...state, pwycAmounts: newAmounts };
        }
        default:
            return state;
    }
}
